import { inchesToPixels, mmToPixels } from "./paper.utils";

export enum PaperSize {
  Letter = "letter",
  Legal = "legal",
  Tabloid = "tabloid",
  Statement = "statement",
  Executive = "executive",
  Folio = "folio",
  A3 = "a3",
  A4 = "a4",
  A5 = "a5",
  B4 = "b4",
  B5 = "b5",
  IndexCard = "indexCard",
  BusinessCard = "businessCard",
}

export const paperSizeOptions = [
  {
    label: `Letter (8.5” x 11”)`,
    value: PaperSize.Letter,
  },
  {
    label: `Legal (8.5” x 14”)`,
    value: PaperSize.Legal,
  },
  {
    label: `Tabloid (11” x 17”)`,
    value: PaperSize.Tabloid,
  },
  {
    label: `Statement (5.5” x 8.5”)`,
    value: PaperSize.Statement,
  },
  {
    label: `Executive (7.25” x 10.5”)`,
    value: PaperSize.Executive,
  },
  {
    label: `Folio (8.5” x 13”)`,
    value: PaperSize.Folio,
  },
  {
    label: `A3 (297mm x 420mm)`,
    value: PaperSize.A3,
  },
  {
    label: `A4 (210mm x 297mm)`,
    value: PaperSize.A4,
  },
  {
    label: `A5 (148mm x 210mm)`,
    value: PaperSize.A5,
  },
  {
    label: `B4 (250mm x 353mm)`,
    value: PaperSize.B4,
  },
  {
    label: `B5 (176mm x 250mm)`,
    value: PaperSize.B5,
  },
  {
    value: PaperSize.IndexCard,
    label: "Index Card (545px x 327px)",
  },
  {
    value: PaperSize.BusinessCard,
    label: "Business Card (381px x 218px)",
  },
];

export type PaperSizeTypes = PaperSize;

export enum PaperOrientation {
  Portrait = "portrait",
  Landscape = "landscape",
}

export const PaperOrientationOptions = [
  {
    value: PaperOrientation.Portrait,
    label: "Portrait",
  },
  {
    value: PaperOrientation.Landscape,
    label: "Landscape",
  },
];

export type PaperOrientationTypes = PaperOrientation;

export enum BackgroundStyle {
  FitCanvas = "Fit Canvas",
  DisplayAsUploaded = "Display as uploaded",
}

export const backgroundStyleOptions = [
  {
    value: BackgroundStyle.FitCanvas,
    label: "Fit Canvas",
  },
  {
    value: BackgroundStyle.DisplayAsUploaded,
    label: "Display as uploaded",
  },
];

export type BackgroundStyleTypes = BackgroundStyle;

export interface PaperSizeConfig {
  width: number;
  height: number;
  orientation: PaperOrientation;
}

export const paperSizeConfigs: Record<PaperSize, PaperSizeConfig> = {
  [PaperSize.Letter]: {
    width: inchesToPixels(8.5),
    height: inchesToPixels(11),
    orientation: PaperOrientation.Portrait,
  },
  [PaperSize.Legal]: {
    width: inchesToPixels(8.5),
    height: inchesToPixels(14),
    orientation: PaperOrientation.Portrait,
  },
  [PaperSize.Tabloid]: {
    width: inchesToPixels(11),
    height: inchesToPixels(17),
    orientation: PaperOrientation.Portrait,
  },
  [PaperSize.Statement]: {
    width: inchesToPixels(5.5),
    height: inchesToPixels(8.5),
    orientation: PaperOrientation.Portrait,
  },
  [PaperSize.Executive]: {
    width: inchesToPixels(7.25),
    height: inchesToPixels(10.5),
    orientation: PaperOrientation.Portrait,
  },
  [PaperSize.Folio]: {
    width: inchesToPixels(8.5),
    height: inchesToPixels(13),
    orientation: PaperOrientation.Portrait,
  },
  [PaperSize.A3]: {
    width: mmToPixels(297),
    height: mmToPixels(420),
    orientation: PaperOrientation.Portrait,
  },
  [PaperSize.A4]: {
    width: mmToPixels(210),
    height: mmToPixels(297),
    orientation: PaperOrientation.Portrait,
  },
  [PaperSize.A5]: {
    width: mmToPixels(148),
    height: mmToPixels(210),
    orientation: PaperOrientation.Portrait,
  },
  [PaperSize.B4]: {
    width: mmToPixels(250),
    height: mmToPixels(353),
    orientation: PaperOrientation.Portrait,
  },
  [PaperSize.B5]: {
    width: mmToPixels(176),
    height: mmToPixels(250),
    orientation: PaperOrientation.Portrait,
  },
  [PaperSize.IndexCard]: {
    width: inchesToPixels(3),
    height: inchesToPixels(5),
    orientation: PaperOrientation.Portrait,
  },
  [PaperSize.BusinessCard]: {
    width: inchesToPixels(2),
    height: inchesToPixels(3.5),
    orientation: PaperOrientation.Portrait,
  },
};
